module.exports = __webpack_public_path__ + "static/media/Printer.6b12a674.svg";